import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { checkForMaintenance } from '../guards/check-for-maintenance.guard.tns.';

@Injectable()
export class PublisherService {
  constructor() {}

  private static signInRequestSource = new Subject();
  static signInRequest$ = PublisherService.signInRequestSource.asObservable();

  private static signOutRequestSource = new Subject();
  static signOutRequest$ = PublisherService.signOutRequestSource.asObservable();

  private static isAuthChangedSource = new Subject<boolean>();
  static isAuthChanged$ = PublisherService.isAuthChangedSource.asObservable();

  private static isAccountChangedSource = new Subject<boolean>();
  static isAccountChanged$ = PublisherService.isAccountChangedSource.asObservable();

  private static isConfigLoadedSource = new Subject<boolean>();
  static isConfigLoaded$ = PublisherService.isConfigLoadedSource.asObservable();

  private static cartCountUpdatedSource = new Subject<number>();
  static cartCountUpdated$ = PublisherService.cartCountUpdatedSource.asObservable();

  private static paymetricAjaxSuccess = new Subject<any>();
  static paymetricAjaxSuccess$ = PublisherService.paymetricAjaxSuccess.asObservable();

  private static searchTriggered = new Subject<any>();
  static searchTriggered$ = PublisherService.searchTriggered.asObservable();

  private static loadUserInfo = new Subject<any>();
  static loadUserInfo$ = PublisherService.loadUserInfo.asObservable();

  private static bannerHeaderChangedSource = new Subject<string>();
  static bannerHeaderChangedSource$ = PublisherService.bannerHeaderChangedSource.asObservable();
  private static exportToExcel = new Subject<string>();
  static exportToExcel$ = PublisherService.exportToExcel.asObservable();

  private static bannerContentChangedSource = new Subject<string>();
  static bannerContentChangedSource$ = PublisherService.bannerContentChangedSource.asObservable();

  private static settingsChangedSource = new Subject<string>();
  static settingsChangedSource$ = PublisherService.settingsChangedSource.asObservable();

  private static changeAccountClickedSource = new Subject<any>();
  static changeAccountClicked$ = PublisherService.changeAccountClickedSource.asObservable();

  private static staticDataLoadedSource = new Subject<any>();
  static staticDataLoaded$ = PublisherService.staticDataLoadedSource.asObservable();

  private static checkForMaintenanceSource = new Subject<any>();
  static checkForMaintenance$ = PublisherService.checkForMaintenanceSource.asObservable();

  static notifyCheckForMaintenance(data?: any) {
    this.checkForMaintenanceSource.next(data);
  }

  static notifyStaticDataLoaded(data?: any) {
    this.staticDataLoadedSource.next(data);
  }

  static notifyLoadUserInfo(data?: any) {
    this.loadUserInfo.next(data);
  }

  static notifySignInRequest(data?: any) {
    this.signInRequestSource.next(data);
  }

  static notifySignOutRequest() {
    this.signOutRequestSource.next();
  }

  static notifyAuth(isAuthenticated: boolean) {
    this.isAuthChangedSource.next(isAuthenticated);
  }

  static notifyAccountChange(isAccountChange: boolean) {
    this.isAccountChangedSource.next(isAccountChange);
  }

  static notifyConfig(isLoaded: boolean) {
    this.isConfigLoadedSource.next(isLoaded);
  }

  static notifyCartCountUpdated(count: any) {
    count = parseInt(count, 0);
    count = count || parseInt(count, 0);
    PublisherService.cartCountUpdatedSource.next(count);
  }

  static notifyAjaxSuccess(success: boolean) {
    this.paymetricAjaxSuccess.next(success);
  }

  static notifySearchTrigger(searchValue: any) {
    this.searchTriggered.next(searchValue);
  }

  static changeBannerHeader(bannerHeader: string) {
    PublisherService.bannerHeaderChangedSource.next(bannerHeader);
  }
  static changeExportToExcel(product: string) {
    PublisherService.exportToExcel.next(product);
  }
  static changeBannerContent(bannerContent: string) {
    PublisherService.bannerContentChangedSource.next(bannerContent);
  }

  static notifyUserSettingsChange() {
    PublisherService.settingsChangedSource.next();
  }

  static changeAccountClicked() {
    PublisherService.changeAccountClickedSource.next();
  }
}
